// Footer.jsx
import React from 'react';
import cl from './Footer.module.css';

import logo from './img/logo.png'

const Footer = () => {
  return (
    <footer className={cl.footer}>
        <div className={cl.footWrap}>
          <div className={cl.footWrap_el_1}>
            <div className={cl.footWrap_el_1_1}>
              <h2>АдминПанель</h2>
              <p>АдминПанель - это система управления детским центром, построенном на базе курсов по программированию (Майнкрафтия) и робототехники (РобоТехника), включающая в себя управление клиентами, журнал, оплаты, CRM систему и многое другое.</p>
            </div>
            <div className={cl.footWrap_el_1_2}>
              <h2>Журнал</h2>
              <p>Ученики</p>
              <p>Журнал</p>
              <p>Мероприятия</p>
              <p>Платежи</p>
              <p>Настройки</p>
            </div>
            <div className={cl.footWrap_el_1_3}>
              <div>
                <h2>Аккаунты</h2>
                <p>Аккаунты учеников</p>
                <p>Преподы и админы</p>
              </div>
              <div className={cl.footWrap_el_1_3_down}>
                <h2>Материалы</h2>
                <p>Статьи и материалы</p>
              </div>
            </div>
            <div className={cl.footWrap_el_1_4}>
              <h2>РобоТехника</h2>
              <p>Прогресс учеников</p>
              <p>Проверка проектов</p>
            </div>
          </div>
          <div className={cl.footWrap_el_2}>
            <p>2024-2025 г.</p>
          </div>
        </div>
    </footer>
  );
};

export default Footer;